import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

const { $ } = window;

const FacetPanelHelp = ({ panelId, popoverDescription }) => {
  const infoPopover = useRef();

  const popoverContent = () => {
    return `<span class='facet_popover_wrapper'>${popoverDescription}</span>`;
  };

  const initPopover = () => {
    if (infoPopover) {
      $(infoPopover.current)
        .popover({ container: 'body' })
        .on('inserted.bs.popover', (e) => {
          const tip = $(e.target).data('bs.popover').tip();
          tip.addClass('facet-popover');
        });
    }
  };

  useEffect(() => {
    initPopover();
  }, [infoPopover]);

  const id = `js-help-${panelId}`;
  const classNames = ['lp-icon', 'fa-regular', 'fa-circle-info', 'ml5'];

  return (
    <i
      ref={infoPopover}
      className={classNames.join(' ')}
      id={id}
      tabIndex="0"
      data-toggle="popover"
      data-content={popoverContent()}
      data-html="true"
      rel="focus-popover"
    />
  );
};

FacetPanelHelp.propTypes = {
  panelId: PropTypes.string,
  popoverDescription: PropTypes.string
};

export default FacetPanelHelp;
